<template><div></div></template>

<script>
import FrontBusiness from "@/business/FrontBusiness";

import ImprimirFichaV2 from "@/components/Livros/ImprimirFichaV2.vue";

//FIXME: Remover este componente
export default {
    name: "ImprimirFicha",
    components: {},

    props: ['tipo', 'id', 'codigo', 'simulacao', 'atosSimulacao'],

    async mounted() {
      this.abrirNovoModelo();
    },

    modal: {
      escapable: true
    },

    methods: {
      abrirNovoModelo(){
        FrontBusiness.closeModal();
        FrontBusiness.openModal(ImprimirFichaV2, {id: this.id, tipo: this.tipo, codigo: this.codigo, simulacao: this.simulacao, atosSimulacao: this.atosSimulacao});
      },
    }
  }
</script>
